// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3Ieg6","boxTitle":"Qualiphy_boxTitle__2RRK4","box":"Qualiphy_box__2iV37","toggleWrap":"Qualiphy_toggleWrap__1MubV"};